import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCryptopunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCryptopunk"><Path d="M5.75 6.75V5.75C5.75 4.09315 7.09315 2.75 8.75 2.75H15.25C16.9069 2.75 18.25 4.09315 18.25 5.75V6.75M5.75 6.75H18.25M5.75 6.75V10.75H4.25V13.75H5.75V21.25M11.25 21.25V19.25H15.25C16.9069 19.25 18.25 17.9069 18.25 16.25V6.75M18.25 6.75H21.25M10.7188 9.94444H10.7291M14.8438 9.94444H14.8541M14.25 15.25C12.5 15.5 10.7291 15.25 10 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCryptopunk;
